// PixSimulationTable.jsx
import { Button } from "../../../../shared/components/button/button";
import { formatValueToMonetary } from "../../../../utils/formatter";
import { Box } from "../../../box";

export function PixSimulationTable({
  amount,
  simulations,
  monthlyInterest,
  selectedSimulation,
  onSelect,
  onContinue,
  onBack,
}) {
  return (
    <Box title={"Simulador de Parcelas"}>

      <p className="text-sm text-gray-600">
        Juros mensal: <strong>{monthlyInterest}% a.m.</strong>
      </p>

      <div className="overflow-x-auto border rounded-xl" style={{ maxHeight: "300px" }}>
        <table className="table table-hover mb-0">
          <thead className="bg-slate-100">
            <tr>
              <th className="p-3 text-left">Parcelas</th>
              <th className="p-3 text-left">Valor da parcela</th>
              <th className="p-3 text-left">Total a pagar</th>
              <th className="p-3 text-left">Juros pagos</th>
            </tr>
          </thead>

          <tbody>
            {simulations.map((item) => {
              const selected =
                selectedSimulation?.installments === item.installments;

              return (
                <tr
                  key={item.installments}
                  onClick={() => onSelect(item)}
                  className={`border-top ${selected ? "table-active" : ""}`}
                  style={{ cursor: "pointer" }}
                >
                  <td>{item.installments}x</td>
                  <td>{formatValueToMonetary(item.installmentValue)}</td>
                  <td>
                    {formatValueToMonetary(item.totalToPay)}
                  </td>
                  <td>
                    {formatValueToMonetary(item.totalToPay - amount)}
                  </td>
                </tr>
              );
            })}
          </tbody>

        </table>
      </div>

      <div className="d-flex justify-content-between col-md-12">
        <Button
          onClick={onBack}
          variant={"secondary"}
          size={'sm'}
        >
          Cancelar
        </Button>
        <Button
          disabled={!selectedSimulation}
          onClick={onContinue}
          variant={selectedSimulation ? "primary" : "disabled"}
          size={'md'}
        >
          Continuar para pagamento
        </Button>
      </div>
    </Box>
  );
}
